module.exports = __webpack_public_path__ + "img/pic15.fcdcfc54.png";